export default function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export function isIosMobileDevice() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}
